export default "__VITE_ASSET__8a2710f3__"